import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationGr from "../assets/locales/gr.json";
import translationIT from "../assets/locales/it.json";
import translationRS from "../assets/locales/ru.json";
import translationSP from "../assets/locales/sp.json";
import translationENG from "../assets/locales/en.json";
import translationCN from "../assets/locales/ch.json";
import translationFR from "../assets/locales/fr.json";
import translationAR from "../assets/locales/ar.json";
import translationTR from "../assets/locales/tr.json";

// the translations
const resources = {
  gr: {
    translation: translationGr,
  },
  it: {
    translation: translationIT,
  },
  rs: {
    translation: translationRS,
  },
  sp: {
    translation: translationSP,
  },
  en: {
    translation: translationENG,
  },
  cn: {
    translation: translationCN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
  tr: {
    translation: translationTR,
  }
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "tr");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "tr",
    fallbackLng: "tr", // use en if detected lng is not available


    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
